/* Dezine Kids — smooth Avone sticky header
   Preserves Avone's original stickyHeader + animated + fadeInDown transition.
   Only improves state handling so the page does not jump when the header becomes fixed. */
(function () {
  if (window.__dkAvoneHeaderSmoothInstalled) return;

  var attempts = 0;
  var maxAttempts = 80;

  function install() {
    if (window.__dkAvoneHeaderSmoothInstalled) return true;
    if (!window.theme || !window.theme.fixedHeader || typeof window.onscroll !== 'function') return false;

    var header = document.getElementById('header');
    var spacer = document.querySelector('.stickySpace');
    if (!header || !spacer) return false;

    var avoneOnScroll = window.onscroll;
    var threshold = 145;
    var isSticky = header.classList.contains('stickyHeader');
    var ticking = false;

    function enterSticky() {
      if (isSticky) return;

      /* Measure and reserve the ORIGINAL in-flow header space first. */
      var height = Math.ceil(header.getBoundingClientRect().height || header.offsetHeight || 0);
      if (height > 0) spacer.style.minHeight = height + 'px';

      /* Keep Avone's original visual transition exactly as intended. */
      header.classList.add('stickyHeader', 'animated', 'fadeInDown');
      isSticky = true;
    }

    function exitSticky() {
      if (!isSticky) return;

      header.classList.remove('stickyHeader', 'fadeInDown');
      spacer.style.minHeight = '';
      isSticky = false;
    }

    function updateHeader() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (y > threshold) enterSticky();
      else exitSticky();
    }

    function scheduleHeaderUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateHeader);
    }

    /* Preserve Avone's original scroll routine for sticky cart / back-to-top,
       but temporarily bypass only its old sticky-header branch. */
    window.onscroll = function (event) {
      var fixedHeaderSetting = window.theme.fixedHeader;
      window.theme.fixedHeader = false;

      try {
        avoneOnScroll.call(window, event);
      } finally {
        window.theme.fixedHeader = fixedHeaderSetting;
      }

      scheduleHeaderUpdate();
    };

    window.addEventListener('resize', scheduleHeaderUpdate, { passive: true });
    window.addEventListener('orientationchange', scheduleHeaderUpdate, { passive: true });

    window.__dkAvoneHeaderSmoothInstalled = true;
    scheduleHeaderUpdate();
    return true;
  }

  function waitForAvone() {
    if (install()) return;
    attempts += 1;
    if (attempts < maxAttempts) window.setTimeout(waitForAvone, 25);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(waitForAvone, 0);
    });
  } else {
    window.setTimeout(waitForAvone, 0);
  }
})();
